
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import '../styleCss/a.css'
const Footer = () => {
    const [showContactInfo, setShowContactInfo] = useState();
    return (
        <div>
            <span className="card"></span>

            <section id="footer">

                <div id="footer1">
                    <Link to="/terms-condition" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none", color: "white" }}> Terms & Conditions</Link>
                    <span className='text-gray-300'> | </span>
                    <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none", color: "white" }}> Privacy Policy</Link>
                    <span className='text-gray-300'> | </span>

                    <Link to="/refund-policy" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none", color: "white" }}> Refund Policy</Link>
                    <span className='text-gray-300' > | </span>
                    <Link to="/sponsership-disclaimer" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none", color: "white" }}>Sponsership Disclaimer</Link>
                    <span className='text-gray-300'> | </span>
                    <Link to="/referral" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: "none", color: "white" }}>  Referral Terms & Conditions   </Link>
                    <span className='text-gray-300'> | </span>


                    <div className="icon-wrapper" id="upgrade" style={{ textDecoration: 'none', color: "white" }}>


                        <button onClick={() => setShowContactInfo(true)}>
                            Contact Us
                        </button>


                    </div>

                </div>

                <div id="footer2">AlgoController automates trade execution by linking your broker and exchange accounts. While powerful, automated trading involves risk. Use with care and ensure you understand the potential impact.

                    By using AlgoController, you accept full responsibility for all trading activity and agree to proceed at your own risk.

                    We are not liable for any losses, technical issues, or third-party errors. You are responsible for monitoring your trades and
                    ensuring proper signal execution.
                    <br /><br />
                    &#xA9; 2025 AlgoController, All rights reserved. <br />
                    Registered MSME (Udyam): UDYAM-HR-15-0030895 ||
                    Verified under Ministry of MSME, Govt. of India
                </div>

            </section>

            <a href="https://wa.me/918684953093?text=Hi" target="_blank" className="chaty-tooltip pos-left" data-form="chaty-form-0-Whatsapp" data-hover="Whatsapp">
                <img src="/assets/chaticon.svg" width="40" height="40" id="uparrow"
                    style={{
                        cursor: "pointer", bottom:
                            "0px", right: "20px",
                        msTransformOrigin: "100% 100%",
                        WebkitTransformOrigin: "100% 100%",
                        transformOrigin: "100% 100%",
                        zIndex: "9999997",
                        position: "fixed"
                    }} />
            </a>


            {showContactInfo && (
                <div className="fixed inset-0 w-full flex items-center justify-center text-white bg-black/40 z-[9999] ">
                    <div className="backdrop-blur-md bg-black border border-white/50 shadow-xl rounded-2xl  p-4 w-[400px] sm:w-[500px] lg:w-[650px] ">
                        {/* Header with title + cross */}
                        <div className="flex items-center justify-between mb-2">
                            <h2 className="text-lg font-semibold text-center flex-1">
                                Contact Details
                            </h2>
                            <button
                                className="text-white hover:text-red-500 text-xl font-bold mb-2"
                                onClick={() => setShowContactInfo(false)} // <- use your state hook here
                            >
                                ×
                            </button>
                        </div>

                        {/* Body */}
                        <div className=" flex flex-row w-full flex-wrap items-center justify-center gap-2">
                            <div className="bg-gray-200 rounded-md px-3 h-12 flex items-center justify-center w-full max-w-xs ">
                                <p className="text-black text-center py-1 ">support@algocontroller.com</p>
                            </div>

                            <div className="bg-gray-200 rounded-md px-4 h-12 flex items-center justify-center w-full max-w-xs">
                                <p className="text-black text-center ">+91 8684953093</p>
                            </div>
                        </div>

                    </div>
                </div>



            )

            }
        </div>
    )
}

export default Footer